const state = {
  currentlyLoading: []
}

const getters = {
  isLoading (state) {
    return state.currentlyLoading.length > 0
  }
}

const mutations = {
  startLoading (state, source) {
    state.currentlyLoading.push(source)
  },
  stopLoading (state, source) {
    state.currentlyLoading = state.currentlyLoading.filter(element => element !== source)
  }
}

const actions = {
  /**
   * Enable loading state
   * @param {Object} context
   * @param {string} source Identifier of the loading state origin point
   */
  startLoading (context, source) {
    context.commit('startLoading', source)
  },
  /**
   * Disable loading state
   * @param {Object} context
   * @param {string} source Identifier of the loading state origin point we wish to stop
   */
  stopLoading (context, source) {
    context.commit('stopLoading', source)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
